module.exports = __webpack_public_path__ + "static/media/icon-menu.45423c04.svg";